import { Skeleton } from '@/components/ui/skeleton';

// `value` accepts a pre-formatted string (e.g. a money tile) as well as a raw
// count — the tile only renders it, and formatting money in the caller keeps
// integer-cent math out of a display component.
type Props = { label: string; value?: number | string; loading?: boolean };

export function KpiTile({ label, value, loading }: Props) {
  return (
    <div className="rounded-[12px] border border-black/[0.05] bg-surface p-4 shadow-card transition-shadow duration-200 hover:shadow-raised">
      <div className="text-[10.5px] font-semibold uppercase tracking-[0.06em] text-subtle">{label}</div>
      {loading ? (
        <Skeleton className="mt-1.5 h-8 w-14" />
      ) : (
        <div className="tnum mt-0.5 text-[27px] font-semibold tracking-tighter">{value ?? '—'}</div>
      )}
    </div>
  );
}
